import ResponsiveBarChartComponent from './ResponsiveBarChart';
import PieChartComponent from './PieChart';

export const PieChart = PieChartComponent;
export const ResponsiveBarChart = ResponsiveBarChartComponent;
